<!------------------------------------------------>
<!--            환불 정보 요약            -->
<!------------------------------------------------>
<template>
  <div v-if="done" class="refund-card">
    <div class="refund-card__inner">
      <div class="refund-card__header">
        <span class="refund-card__title">환불 정보</span>
      </div>

      <div class="refund-card__section">
        <div class="refund-card__label" v-if="isPromotion">적용된 프로모션 요금제</div>
        <div class="refund-card__label" v-else>적용된 요금제</div>
        <div class="refund-card__value refund-card__value--primary">
          <template v-if="isPromotion">
            {{ `${cancelInfo.feeName} (년 ${formatToKoreanWon(cancelInfo.amountPerMonth)}원)` }}
          </template>
          <template v-else>
            {{ `${cancelInfo.feeName} (월 ${formatToKoreanWon(cancelInfo.feeOriginAmount)}원)` }}
          </template>
        </div>
      </div>

      <div v-if="cancelInfo.discountMethod" class="refund-card__section refund-card__section--discount">
        <div class="refund-card__label">적용된 할인</div>
        <div class="refund-card__value" v-if="cancelInfo.discountMethod === '00001'">
          {{ `${cancelInfo.discountName} (월 요금 ${formatToKoreanWon(cancelInfo.discountAmount)}원 할인)` }}
        </div>
        <div class="refund-card__value" v-if="cancelInfo.discountMethod === '00002'">
          {{ `${cancelInfo.discountName} (월 요금 ${cancelInfo.discountPercent}% 할인)` }}
        </div>
      </div>

      <!-- 프로모션 요금제 -->
      <template v-if="isPromotion">
        <div class="refund-card__section refund-card__section--total">
          <div class="refund-card__label">최종 환불 금액(VAT 10% 포함)</div>
          <v-text-field class="refund-card__total-input editor_bg rounded right-input" readonly solo suffix="원" :value="formatToKoreanWon(0)" />
        </div>
      </template>

      <!-- 공사기간 지났을 때 -->
      <template v-else-if="propsData.constructDtE.replaceAll('-', '') <= requestDt">
        <div class="refund-card__section refund-card__section--breakdown">
          <div v-if="remark != ''" class="refund-card__remark">
            <span class="refund-card__remark-label">비고:</span>
            <span class="refund-card__remark-text">사용기간 종료, 환불 불가</span>
          </div>
        </div>
        <div class="refund-card__section refund-card__section--total">
          <div class="refund-card__label">최종 환불 금액(VAT 10% 포함)</div>
          <v-text-field
            class="refund-card__total-input editor_bg rounded right-input"
            readonly
            solo
            suffix="원"
            :value="formatToKoreanWon(cancelInfo.paymentAmount)"
          />
        </div>
      </template>

      <!-- 일반 환불 계산 -->
      <template v-else>
        <div class="refund-card__section refund-card__section--total">
          <div class="refund-card__label">최종 환불 금액(VAT 10% 포함)</div>
          <v-text-field
            class="refund-card__total-input editor_bg rounded right-input"
            readonly
            solo
            suffix="원"
            :value="formatToKoreanWon(cancelInfo.paymentAmount)"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
// 컴포넌트
import baseview from '@/views/base/baseview.vue'
// api
import { getCustomerLoginHistoryAferPayment, requestCancel } from '@/payment/api/toss'

import { getCancelSummary } from '@/api/adminManagement/cancelManage'

import { getCurrentDate } from '@/utils/common.js'
//
export default {
  mixins: [baseview],
  components: {},
  name: 'cancelSummary',
  props: {
    orderId: {
      type: String,
      default: () => '', // 랜더링 키값
    },
    isPromotion: {
      type: Boolean,
      default: () => false, // 프로모션 요금제 여부
    },
    propsData: {
      type: Object,
      default: () => {}, // 프로모션 요금제 여부
    },
  },
  data() {
    return {
      cancelInfo: {},
      done: false,
      remark: '',
      requestDt: getCurrentDate().replaceAll('-', ''),
      isFullRefund: false,
    }
  },
  watch: {
    orderId: {
      deep: true,
      handler() {
        this.btnSearch()
      },
    },
  },
  activated() {},
  created() {
    this.btnSearch()
  },
  mounted() {
    this.btnSearch()
  },
  methods: {
    formatToKoreanWon(value) {
      if (value) {
        const numberValue = parseFloat(value.toString().replace(/,/g, ''))
        if (!isNaN(numberValue)) {
          return numberValue.toLocaleString('ko-KR')
        }
      }
      return 0
    },
    btnSearch() {
      if (!this.orderId) return
      this.done = false
      this.cancelInfo = {}
      console.log('#### 환불 정보 ', this.propsData)

      const param = {
        clntId: this.propsData.clntId,
        compId: this.propsData.compId,
        writeDt: this.propsData.writeDt,
        docNo: this.propsData.docNo,
        orderId: this.orderId,
      }
      getCancelSummary(param, true).then((res) => {
        this.cancelInfo = res
        this.done = true
        this.$emit('done', true)
        const customerParam = {
          clntId: this.getClntId(),
          orderId: this.orderId,
        }
        // 로그인 여부 조회
        // getCustomerLoginHistoryAferPayment(customerParam)
        //   .then((res) => {
        //     if (res.loginDate) {
        //       this.customerLoginDate = res.loginDate
        //     }
        //   })
        //   .finally(() => {
        //     console.log('### this.cancelInfo', this.cancelInfo)
        //     console.log('### this.this.customerLoginDate', this.customerLoginDate)
        //     if (this.cancelInfo.paymentStatus == 'N') {
        //       this.cancelInfo.refundAmount = this.cancelInfo.paymentAmount
        //       this.remark = '결제 승인 전, 전액 환불'
        //       this.isFullRefund = true
        //     } else if (!this.customerLoginDate && this.cancelInfo.useMonth == 0) {
        //       console.log('### this.this.customerLoginDate')
        //       if (this.cancelInfo.useDay <= 7) {
        //         //미사용 7일 이내
        //         this.cancelInfo.refundAmount = this.cancelInfo.paymentAmount
        //         this.remark = '미사용 7일 이내, 컨설팅 비용 제외 전액 환불'
        //         this.isFullRefund = true
        //       } else {
        //         // 월 요금의 1/3만 차감하여 계산
        //         this.cancelInfo.refundAmount = Math.ceil(this.cancelInfo.paymentAmount - this.cancelInfo.amountPerMonth / 3)
        //         this.remark = '미사용 1개월 이내, 월요금의 1/3만 차감'
        //         this.isFullRefund = false
        //       }
        //     } else if (this.cancelInfo.remainMonth === 0 && this.cancelInfo.remainDay < 7) {
        //       this.cancelInfo.refundAmount = 0
        //       this.remark = '남은 사용 기간 7일 미만, 환불 불가'
        //       this.isFullRefund = false
        //     }
        //     if (this.propsData.constructDtE.replaceAll('-', '') <= this.requestDt) {
        //       this.requestDt = getCurrentDate().replaceAll('-', '')
        //       this.cancelInfo.refundAmount = 0
        //     }
        //     this.done = true
        //     this.$emit('done', true)
        //   })
      })
    },
    getAmount() {
      // VAT 포함 금액 호출 시 true
    //   console.log('##### this.cancelInfo.refundAmount', this.cancelInfo.refundAmount)
    //   return this.cancelInfo.refundAmount
    },
  },
}
</script>
<style scoped>
.refund-card {
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.06);
  background: #fff;
}

.refund-card__inner {
  padding: 0;
}

.refund-card__header {
  padding: 14px 20px;
  background: linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%);
  color: #fff;
}

.refund-card__title {
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: -0.02em;
}

.refund-card__section {
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
}

.refund-card__section:last-child {
  border-bottom: none;
}

.refund-card__section--total {
  background: #faf5ff;
  padding: 18px 20px;
}

.refund-card__section--discount {
  background: #fefdf8;
}

.refund-card__section--breakdown {
  background: #fafbfc;
}

.refund-card__label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 6px;
}

.refund-card__value {
  font-size: 0.9375rem;
  color: #1e293b;
  line-height: 1.5;
}

.refund-card__value--primary {
  font-weight: 600;
  color: #0f172a;
}

.refund-card__detail {
  margin-top: 4px;
}

.refund-card__row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 6px 0;
  font-size: 0.875rem;
  color: #334155;
  line-height: 1.5;
  gap: 4px 8px;
}

.refund-card__row--sub {
  padding-top: 10px;
  margin-top: 4px;
  border-top: 1px dashed #e2e8f0;
}

.refund-card__row-label {
  color: #64748b;
}

.refund-card__row-value {
  color: #1e293b;
  font-weight: 500;
}

.refund-card__row-op {
  margin: 0 4px;
  color: #94a3b8;
  font-weight: 500;
}

.refund-card__remark {
  margin-top: 10px;
  padding: 10px 12px;
  background: #fef3c7;
  border-radius: 8px;
  border-left: 3px solid #f59e0b;
  font-size: 0.875rem;
}

.refund-card__remark-label {
  font-weight: 600;
  color: #92400e;
  margin-right: 6px;
}

.refund-card__remark-text {
  color: #78350f;
}

.refund-card__total-input >>> .v-input__slot {
  background: #fff !important;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

.refund-card__total-input >>> input {
  text-align: right;
  font-size: 1.125rem !important;
  font-weight: 700 !important;
  color: #0f172a !important;
}

.right-input >>> input {
  text-align: right;
}
</style>
